<template>
  <div class="crm-follow-upload">
    <a-upload
      :accept="accept"
      :disabled="disabled"
      :file-list="fileList"
      :list-type="kind === 'photo' ? 'picture-card' : 'text'"
      :multiple="count > 1"
      :before-upload="beforeUpload"
      :custom-request="uploadFile"
      :remove="removeFile"
      @preview="previewFile">
      <div v-if="!disabled && fileList.length < count">
        <template v-if="kind === 'photo'">
          <a-icon :type="uploading ? 'loading' : 'camera'" />
          <div class="upload-label">{{ uploading ? '上传中' : '上传照片' }}</div>
        </template>
        <a-button v-else :loading="uploading" icon="paper-clip">添加附件</a-button>
      </div>
    </a-upload>
    <small>{{ hint }}</small>
  </div>
</template>

<script>
import { uploadCrmFollowUpAttachment } from '@/api/erp/crm'

export default {
  name: 'CrmFollowUpUpload',
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: String, default: '' },
    kind: { type: String, default: 'attachment' },
    count: { type: Number, default: 6 },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return { fileList: [], uploading: false }
  },
  computed: {
    accept () { return this.kind === 'photo' ? '.jpg,.jpeg,.png' : '.jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx' },
    hint () { return this.kind === 'photo' ? `JPG/PNG，单个不超过10MB，最多${this.count}张` : `支持图片、PDF、Word、Excel，单个不超过10MB，最多${this.count}个` }
  },
  watch: {
    value: { immediate: true, handler (value) { this.syncFromValue(value) } }
  },
  methods: {
    syncFromValue (value) {
      const urls = this.splitUrls(value)
      if (urls.join(',') === this.fileList.map(item => item.url).join(',')) return
      this.fileList = urls.map((url, index) => ({ uid: `saved-${index}-${url}`, name: this.fileName(url), status: 'done', url }))
    },
    splitUrls (value) { return String(value || '').split(',').map(item => item.trim()).filter(Boolean) },
    fileName (url) {
      const clean = String(url || '').split('?')[0]
      try { return decodeURIComponent(clean.substring(clean.lastIndexOf('/') + 1)) || '附件' } catch (e) { return clean.substring(clean.lastIndexOf('/') + 1) || '附件' }
    },
    beforeUpload (file) {
      if (this.fileList.length >= this.count) { this.$message.warning(`最多上传${this.count}个文件`); return false }
      const extension = String(file.name || '').split('.').pop().toLowerCase()
      const allowed = this.kind === 'photo' ? ['jpg', 'jpeg', 'png'] : ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx']
      if (!allowed.includes(extension)) { this.$message.error(this.kind === 'photo' ? '现场照片仅支持JPG或PNG' : '附件仅支持图片、PDF、Word或Excel'); return false }
      if (file.size > 10 * 1024 * 1024) { this.$message.error('单个文件不能超过10MB'); return false }
      return true
    },
    uploadFile ({ file, onSuccess, onError }) {
      const formData = new FormData()
      formData.append('file', file)
      this.uploading = true
      uploadCrmFollowUpAttachment(formData).then(res => {
        const url = res.data
        this.fileList = this.fileList.concat([{ uid: file.uid, name: file.name, status: 'done', url }])
        this.emitValue()
        onSuccess(res, file)
      }).catch(error => {
        this.$message.error((error && error.message) || '文件上传失败')
        onError(error)
      }).finally(() => { this.uploading = false })
    },
    removeFile (file) {
      if (this.disabled) return false
      this.fileList = this.fileList.filter(item => item.uid !== file.uid)
      this.emitValue()
      return false
    },
    emitValue () { this.$emit('input', this.fileList.map(item => item.url).filter(Boolean).join(',')) },
    previewFile (file) { if (file.url) window.open(file.url, '_blank', 'noopener,noreferrer') }
  }
}
</script>

<style scoped>
.crm-follow-upload small{display:block;margin-top:7px;color:#8a94a3;line-height:1.5}.upload-label{margin-top:5px;font-size:12px}.crm-follow-upload /deep/ .ant-upload-list-item-name{max-width:360px}
</style>
